// extracted by mini-css-extract-plugin
export default {"landing":"Landing_landing__2XbXv","food-appear":"Landing_food-appear__DYJwU","form":"Landing_form__Ohhq4","header":"Landing_header__A6+9B"};